import { useState, useEffect, useCallback } from 'react'

export const useScreenSize = (delay: number = 100) => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)

  const debouncedUpdateDimension = useCallback(() => {
    const timeoutId = setTimeout(() => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }, delay)

    return () => clearTimeout(timeoutId)
  }, [delay])

  useEffect(() => {
    let cleanup: (() => void) | undefined

    const handleResize = () => {
      if (cleanup) cleanup()
      cleanup = debouncedUpdateDimension()
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      if (cleanup) cleanup()
    }
  }, [debouncedUpdateDimension])

  return { width, height }
}

export const useDeprecatedScreenSize = () => {
  const [width, setWidth] = useState(screen.width)
  const [height, setHeight] = useState(screen.height)

  useEffect(() => {
    const updateDimension = () => {
      setWidth(screen.width)
      setHeight(screen.height)
    }

    window.addEventListener('resize', updateDimension)

    return () => {
      window.removeEventListener('resize', updateDimension)
    }
  }, [])

  return { width, height }
}
